import * as languageActions from "./language.actions";

export const languageFeatureKey = "languageInfo";

const initialState = {
    selectedLanguage: {},
    errorMsg: ""
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case languageActions.CHANGE_LANGUAGE_SUCCESS:
            return {
                ...state,
                selectedLanguage: payload
            }

        case languageActions.CHANGE_LANGUAGE_FAILURE:
            return {
                ...state,
                errorMsg: payload
            }

        default: return state;
    }
};